// removed by extract-text-webpack-plugin
module.exports = {"Header_calendarMantainer":"Header__Header_calendarMantainer___2c-rW"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/admin/CalendarMaintainer/components/Header.css
// module id = 1100
// module chunks = 0